import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LicenseInfo } from '@mui/x-license';
import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './globalStyles/picker.scss';
import './globalStyles/hypertrackerChartStyles.scss';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { initSentry } from '@/lib/sentry/sentry';
import polyfill from '@/lib/helpers/polyfill';

LicenseInfo.setLicenseKey(import.meta.env.REACT_APP_MUI || '');
const container = document.getElementById('root');

initSentry();
polyfill();

const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </PersistGate>
    </Provider>,
);

// // Preventing logs on the prod
// function noop() {}

// if (import.meta.env.REACT_APP_ENVR !== 'dev') {
//     console.log = noop;
//     console.info = noop;
// }
